export default {
  title: 'Start dit abonnement',
  title_confirm: 'Bekræft dit abonnement',
  step: 'Trin {{current}} af {{total}}',
  subtitle: '{{name}} · 1 lokation',
  trial_badge: '{{days}} dage gratis',
  trial_headline: 'De første {{days}} dage er gratis',
  then_price: 'Derefter {{price}} / måned pr. lokation · inkl. gældende moms',
  price_per_month: '{{price}} / måned',
  price_terms: 'Pr. lokation, faktureres månedligt · inkl. gældende moms',
  tier_upsell:
    'Skaler til {{threshold}}+ aktive lokationer, og prisen for alle dine lokationer falder til {{price}} / måned pr. lokation – automatisk.',
  tier_active: 'Mængderabat — {{threshold}}+ aktive lokationer',
  due_today: 'Til betaling i dag',
  from_date: 'Fra {{date}}',
  no_charge_today: 'Du bliver ikke opkrævet noget i dag.',
  no_charge_until: 'Du bliver ikke opkrævet i dag. Opsig senest den {{date}}, og du betaler ingenting.',
  active: '{{plan}} er aktiv for denne restaurant.',
  active_with_trial: '{{plan}} er aktiv for denne restaurant, gratis indtil {{date}}.',
  terms:
    'Jeg accepterer <a href="{{terms_url}}" target="_blank" rel="noreferrer">FoodAmigos\' vilkår for partnerplatformen</a>, herunder aktivering, opsigelse og refundering.',
  error: 'Vi kunne ikke gennemføre købet. Prøv igen.',
  loading: 'Tjekker denne restaurants abonnement…',
  load_error: 'Vi kunne ikke tjekke denne restaurants abonnement.',
  unavailable: 'Dette produkt er ikke tilgængeligt for denne restaurant. Kontakt din FoodAmigos-kontoansvarlige.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Online bestilling',
          description: 'Direkte bestillinger på restaurantens eget brandede website',
        },
        reservations: {
          title: 'Bordreservationer',
          description: 'Gæster booker bord direkte online',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Offer Builder, loyalitetsprogram med point og AI-svar på Google-anmeldelser',
        },
        pricing: {
          title: '0 % provision, ingen oprettelsesgebyr',
          description: 'Én licens pr. lokation, faktureres månedligt',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'Restaurantens egen brandede app',
          description: 'I App Store og på Google Play',
        },
        engagement: {
          title: 'Push-notifikationer og loyalitet',
          description: 'Få gæster til at vende tilbage med tilbud og point',
        },
        ordering: {
          title: 'Bestilling uden provision',
          description: 'Direkte bestillinger lige fra appen',
        },
        apple: {
          title: 'Apple Developer-konto påkrævet',
          description: '99 $/år, betales til Apple, i restaurantens juridiske enhed',
        },
      },
    },
    ai_website: {
      title: 'Abonnement på Website Builder',
      subtitle_domain: 'Få {{name}}s website live på {{domain}}',
      features: {
        domain: {
          title: 'Dit website, live på dit eget domæne',
          description: 'Restaurantens brandede website',
        },
        ai: {
          title: 'Bygget og opdateret med AI',
          description: 'Opret sider, tekster og billeder til restauranten på få minutter',
        },
        ordering: {
          title: 'Bestilling og reservationer indbygget',
          description: 'Gæster bestiller og booker bord direkte fra websitet',
        },
        pricing: {
          title: 'Ingen oprettelsesgebyr',
          description: 'Én licens pr. lokation, faktureres månedligt',
        },
      },
    },
    storefront: {
      title: 'Abonnement på Website Builder',
      subtitle_domain: 'Få {{name}}s website live på {{domain}}',
      features: {
        domain: {
          title: 'Dit website, live på dit eget domæne',
          description: 'Restaurantens brandede website',
        },
        ai: {
          title: 'Bygget og opdateret med AI',
          description: 'Opret sider, tekster og billeder til restauranten på få minutter',
        },
        ordering: {
          title: 'Bestilling og reservationer indbygget',
          description: 'Gæster bestiller og booker bord direkte fra websitet',
        },
        pricing: {
          title: 'Ingen oprettelsesgebyr',
          description: 'Én licens pr. lokation, faktureres månedligt',
        },
      },
    },
  },
  payment_method: {
    label: 'Din partners betalingsmetode',
    on_file: 'Kort gemt',
    pending_title: 'Bekræfter din betalingsmetode',
    pending: 'Stripe er stadig ved at bekræfte det kort, du netop har tilføjet. Det kan tage et minut.',
    still_pending: 'Endnu ikke klar. Vent et øjeblik, og tjek igen.',
    error: 'Vi kunne ikke åbne betalingsformularen. Prøv igen.',
  },
  buttons: {
    close: 'Luk',
    continue_to_payment: 'Fortsæt til betaling',
    start_trial: 'Start {{days}} dages gratis prøveperiode',
    subscribe: 'Start abonnement',
    continue: 'Fortsæt',
    change: 'Skift',
    retry: 'Prøv igen',
    check_again: 'Tjek igen',
    add_again: 'Tilføj et kort igen',
  },
};
